<mat-card class="form-ui">
  @if (batch) {
    <div class="row">
      <div class="col-md-6">
        <mat-card-title>{{batch.batch_number}}</mat-card-title>
      </div>
      @if (perm.canMutate()) {
        <div class="col-md-6 text-end">
          <button (click)="editMode = !editMode" mat-flat-button color="primary" class="mb-2 me-2">
            {{ editMode ? 'Details' : 'Edit'}}
          </button>
        </div>
      }
    </div>
  }

  <p class="mt-3 mb-2">
    <button mat-stroked-button (click)="backToList()" class="me-2">
      <mat-icon>arrow_back</mat-icon> Back to list
    </button>
    <button mat-stroked-button (click)="printBarcode()" class="me-2">
      <mat-icon>print</mat-icon> Print barcode
    </button>
  </p>

  @if (!editMode && batch) {
    <div class="mt-2">
      <div class="details">
        <table>
          <tr>
            <th>Batch number</th>
            <td>{{batch.batch_number}}</td>
          </tr>
          <tr>
            <th>Medicine</th>
            <td>{{ batchMedicine ? batchMedicine.name : ''}}</td>
          </tr>
          <tr>
            <th>Dosage type</th>
            <td>{{ batchMedicineDosageType ? batchMedicineDosageType.additional_information : ''}}</td>
          </tr>
          <tr>
            <th>Package type</th>
            <td>{{batchMedicineDosagePackageType ? batchMedicineDosagePackageType.package_type.type + ' (' +
            batchMedicineDosagePackageType.contained_quantity + ')' : '' }}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{{ batch.status ? batch.status.status : '-'}}</td>
          </tr>
          <tr>
            <th>Quantity produced</th>
            <td>{{batch.quantity_produced}}</td>
          </tr>
          <tr>
            <th>Quantity remaining</th>
            <td>{{batch.remaining_quantity}}</td>
          </tr>
          <tr>
            <th>Expiry date</th>
            <td>{{utilService.bestBeforeTime(batch.expiry_date)}}</td>
          </tr>
          <tr>
            <th>Created</th>
            <td>{{utilService.formatTime(batch.created_at)}}</td>
          </tr>
          <tr>
            <th>Updated</th>
            <td>{{utilService.formatTime(batch.updated_at)}}</td>
          </tr>
        </table>
      </div>
      @if (batch.additional_information) {
        <div class="mt-4">
          <div class="py-2">
            <mat-divider></mat-divider>
          </div>
          <h2 class="my-2" mat-card-subtitle>Additional information</h2>
          <quill-view [content]="batch.additional_information" format="html" theme="snow"></quill-view>
        </div>
      }
      <div class="py-2">
        <mat-divider></mat-divider>
      </div>
      <h2 class="pt-4" mat-card-subtitle>Fulfilled orders</h2>
      @if (!fulfilledOrders) {
        <mat-progress-bar mode="buffer"></mat-progress-bar>
      }
      @if (fulfilledOrders) {
        @for (order of fulfilledOrders; track order) {
          <div class="py-2">
            <mat-card class="mb-2">
              <h4 mat-card-subtitle>Order #{{order.id}}</h4>
              <app-batch-order-item-list [order]="order" [orderItems]="order.order_items">
              </app-batch-order-item-list>
            </mat-card>
          </div>
        }
      }
    </div>
  }


  @if (editMode && batch) {
    <form class="mt-3" [formGroup]="batchDetailsForm" (ngSubmit)="submitData()">
      <div class="row">
        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Batch number</mat-label>
              <input required type="text" readonly formControlName="batchNumber" matInput
                placeholder="Batch number">
              @if (batchDetailsForm.get('batchNumber')?.invalid) {
                <mat-error>
                  Batch number is required
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Quantity</mat-label>
              <input required formControlName="quantity" matInput placeholder="Quantity">
              @if (batchDetailsForm.get('quantity')?.invalid) {
                <mat-error>
                  Batch quantity is required
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Select package type</mat-label>
              <mat-select required formControlName="packageTypeId">
                @for (type of medicineDosagePackageTypes; track type) {
                  <mat-option [value]="type.id">
                    {{type.package_type.type}} ({{type.contained_quantity}})
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Expiry date</mat-label>
              <input required data-testid="expiry-date" formControlName="expiryDate" matInput
                [matDatepicker]="picker1">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              @if (batchDetailsForm.get('expiryDate')?.invalid) {
                <mat-error>
                  Expiry date is invalid
                </mat-error>
              }
            </mat-form-field>
          </p>
        </div>
        <div class="col-md-6">
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Medicine</mat-label>
              <input type="text" required placeholder="Search for medicine" aria-label="Search for medicine"
                matInput formControlName="medicine" [matAutocomplete]="auto">
              <mat-autocomplete (optionSelected)="medicineSelected($event)" autoActiveFirstOption
                #auto="matAutocomplete">
                @for (med of medicine; track med) {
                  <mat-option [value]="med">
                    {{med.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Dosage type</mat-label>
              <mat-select required formControlName="medicineDosageType"
                (selectionChange)="getMedicineDosagePackageTypes($event)">
                @for (type of medicineDosageTypes; track type) {
                  <mat-option [value]="type">
                    {{type.additional_information}}
                  </mat-option>
                }
              </mat-select>
              @if (batchDetailsForm.get('dosageTypeId')?.invalid) {
                <mat-error>
                  Batch dosage type is required
                </mat-error>
              }
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select required formControlName="statusId">
                @for (status of batchStatuses; track status) {
                  <mat-option [disabled]="status.code === 'DPL' && batch.remaining_quantity > 0" [value]="status.id">
                    {{status.status}}
                  </mat-option>
                }
              </mat-select>
              @if (batchDetailsForm.get('statusId')?.invalid) {
                <mat-error>
                  Status is required
                </mat-error>
              }
            </mat-form-field>
          </p>
        </div>
      </div>
      <h4>Additional information</h4>
      <quill-editor formControlName="additional_information" format="html" [styles]="{minHeight: '100px'}">
      </quill-editor>
      <div class="mt-2 text-end">
        <button [disabled]="!batchDetailsForm.valid" color="primary" mat-raised-button (click)="submitData()">
          <mat-icon>save</mat-icon> Save
        </button>
      </div>
    </form>
  }
</mat-card>